function $1254bbba71b22eb7$export$e6889fb0929ccf91(popup) {
    popup.classList.add("hidden");
}
function $1254bbba71b22eb7$export$c70811ece640d3a1(popup) {
    popup.classList.remove("hidden");
}
function $1254bbba71b22eb7$export$47d55f168f2d72ec() {
    const popups = Array.from(document.querySelectorAll(".popup"));
    // adds Eventlistenerst for closing popups
    popups.forEach((popup)=>{
        if (popup.classList.contains("consent")) return;
        popup.addEventListener("click", function(e) {
            const clicked = e.target;
            if (!clicked.classList.contains("popup") && !clicked.classList.contains("popup__close")) return;
            $1254bbba71b22eb7$export$e6889fb0929ccf91(popup);
        });
    });
    // to make an image zoomable give it the class of img-zoomable
    const zoomableImgs = Array.from(document.querySelectorAll(".img-zoomable"));
    const imgPopup = document.querySelector("#imgPopup");
    // adds Eventlisteners for zoomable images to open popups
    zoomableImgs.forEach((img)=>{
        img.addEventListener("click", function() {
            img = img.cloneNode();
            img.setAttribute("class", "popup__img");
            img.setAttribute("style", "");
            imgPopup.innerHTML = `<div class="popup__close">x</div>`;
            imgPopup.insertAdjacentElement("beforeend", img);
            $1254bbba71b22eb7$export$c70811ece640d3a1(imgPopup);
        });
    });
}


(0, $1254bbba71b22eb7$export$47d55f168f2d72ec)();
const $4daa164501cabb98$var$consentPopup = document.querySelector(".consent");
const $4daa164501cabb98$var$consentForm1 = document.getElementById("consentForm1");
const $4daa164501cabb98$var$consentForm2 = document.getElementById("consentForm2");
const $4daa164501cabb98$var$btnAccept = document.getElementById("consentBtnAccept");
const $4daa164501cabb98$var$btnCookies = document.getElementById("consentBtnCookies");
const $4daa164501cabb98$var$btnSave = document.getElementById("consentBtnSave");
const $4daa164501cabb98$var$btnReset = document.getElementById("btnResetCookies");
const $4daa164501cabb98$var$consentCheckbox = document.getElementById("consentPersonal");
let $4daa164501cabb98$var$consent = localStorage.getItem("consent");
if ($4daa164501cabb98$var$consent != "true" && $4daa164501cabb98$var$consent != "false") (0, $1254bbba71b22eb7$export$c70811ece640d3a1)($4daa164501cabb98$var$consentPopup);
const $4daa164501cabb98$var$saveConsent = function(consent) {
    localStorage.setItem("consent", consent);
    $4daa164501cabb98$var$consentForm1.submit();
};
const $4daa164501cabb98$var$loadForm2 = function() {
    $4daa164501cabb98$var$consentForm1.classList.add("hidden");
    $4daa164501cabb98$var$consentForm2.classList.remove("hidden");
};
const $4daa164501cabb98$var$resetConsent = function() {
    localStorage.removeItem("theme");
    localStorage.removeItem("consent");
};
const $4daa164501cabb98$var$getFormInput = function() {
    $4daa164501cabb98$var$consent = $4daa164501cabb98$var$consentCheckbox.checked;
    if (!$4daa164501cabb98$var$consent) $4daa164501cabb98$var$resetConsent();
    localStorage.setItem("consent", $4daa164501cabb98$var$consent);
    $4daa164501cabb98$var$consentForm2.submit();
};
$4daa164501cabb98$var$btnAccept.addEventListener("click", function(e) {
    e.preventDefault();
    $4daa164501cabb98$var$saveConsent(true);
});
$4daa164501cabb98$var$btnCookies.addEventListener("click", function(e) {
    e.preventDefault();
    $4daa164501cabb98$var$loadForm2();
});
$4daa164501cabb98$var$btnSave.addEventListener("click", function(e) {
    e.preventDefault();
    $4daa164501cabb98$var$getFormInput();
});
$4daa164501cabb98$var$btnReset.addEventListener("click", function(e) {
    e.preventDefault();
    (0, $1254bbba71b22eb7$export$c70811ece640d3a1)($4daa164501cabb98$var$consentPopup);
});


//# sourceMappingURL=index.b9f82997.js.map
